import { toast as toastLib } from 'react-toastify';

const toast = {
  success(message = 'Successfully.', options) {
    toastLib.success(message, options);
  },
  error(message = 'Cannot submit request', options = {}) {
    toastLib.error(message, {
      ...options,
      icon: ({ theme, type }) => <img src="/assets/images/icon_toast.svg" alt="" />
    });
  },
  loading(message, options) {
    toastLib.info('Please wait!', options);
  },
  promise(promise) {
    return toastLib.promise(
      promise,
      {
        error: {
          render({ data }) {
            // try {
            //   throw new Error(data.message);
            // } catch (error) {
            //   console.log(error);
            // }
            // console.log(data);
            // const regex = /Error: (.*?) \(action=/;
            // const match = regex.exec(data);
            // if (match && match[1]) {
            //   return <span style={{ textTransform: 'capitalize' }}>{match[1]}</span>;
            // }

            return <span style={{ textTransform: 'capitalize' }}>{data?.toString()}</span>;
          }
        },
        success: {
          render({ data }) {
            return 'Successfully';
          }
        },
        pending: 'Please wait!'
      }
    );
  }
};
export default toast;
